import { type ReactNode } from 'react';

interface PageTransitionProps {
  children: ReactNode;
}

export default function PageTransition({ children }: PageTransitionProps) {
  return <div className="page-transition animate-fade-in-up">{children}</div>;
}
